'use client';

import type { GfProductColor } from '@/types';
import styles from './GfColorSwatches.module.scss';

function GfColorSwatches({
  colors,
  onColorSelect,
  selectedColorId,
  showColorName = true,
  iconSize = 'default',
}: {
  colors: GfProductColor[];
  onColorSelect?: (colorId: number) => void;
  selectedColorId: number;
  showColorName?: boolean;
  iconSize?: 'small' | 'default';
}) {
  const handleColorClick = (colorId: number) => {
    onColorSelect?.(colorId);
  };

  return (
    <div className={`${styles.productColorsContainer} ${styles[`${iconSize}Container`]}`}>
      {colors.map((color) => {
        const isSelected = selectedColorId === color.id;
        return (
          <button
            type='button'
            className={`${styles.productColorItemContainer} ${styles[`${iconSize}ItemContainer`]}`}
            key={color.id}
            onClick={() => handleColorClick(color.id)}
            aria-label={color.name}
            aria-pressed={isSelected}
            data-testid={`product-color-option-${color.id}`}
          >
            <div
              className={`${styles.productColorItem} ${styles[`${iconSize}ColorItem`]} ${isSelected ? styles.activeCircle : ''}`}
              style={{ backgroundColor: color.colorCode }}
            />
            {showColorName && <p className={styles.productColorName}>{color.name}</p>}
          </button>
        );
      })}
    </div>
  );
}

export default GfColorSwatches;
